import { atom } from 'jotai';

import { purchaseLoadNotesUpdateAtom } from '../_graphql/mutationPurchaseLoadNotesUpdate';

import { createAutoSaveFormAtoms } from './createAutoSaveFormAtoms.state';
import {
  $inboundTicketLoads,
  $scaleTicketDetail,
  $scaleTicketId,
} from './scaleTicketPro.state';

export type TicketNotesFormState = {
  internalNotes: string | null;
  externalNotes: string | null;
};

export const DEFAULT_NOTES_FORM: TicketNotesFormState = {
  internalNotes: null,
  externalNotes: null,
};

type TicketNotesServerData = {
  internalNotes: string | null;
  externalNotes: string | null;
};

const atoms = createAutoSaveFormAtoms<
  TicketNotesFormState,
  TicketNotesServerData
>({
  defaultForm: DEFAULT_NOTES_FORM,
  fromServerData: (ticket) => ({
    internalNotes: ticket.internalNotes,
    externalNotes: ticket.externalNotes,
  }),
  createMutation: (onSuccess, onError) => {
    const $mut = purchaseLoadNotesUpdateAtom({
      onSuccess: (get, set, { params }) => onSuccess(get, set, params.id),
      onError: (get, set, { params }) => onError(get, set, params.id),
    });
    return atom(
      null,
      (_get, set, params: { ticketId: string; form: TicketNotesFormState }) => {
        set($mut, {
          id: params.ticketId,
          internalNotes: params.form.internalNotes ?? '',
          externalNotes: params.form.externalNotes ?? '',
        });
      },
    );
  },
  refetchOnSuccess: (get, ticketId) => {
    if (get($scaleTicketId) === ticketId) {
      get($scaleTicketDetail).refetch();
    }
    get($inboundTicketLoads).refetch();
  },
});

export const $ticketNotesFormById = atoms.$formById;
export const $ticketNotesBaselineById = atoms.$baselineById;
export const $updateTicketNotesField = atoms.$updateField;
export const $syncTicketNotesForm = atoms.$syncForm;
export const $flushTicketNotesAutoSave = atoms.$flushAutoSave;
export const $cancelTicketNotesAutoSave = atoms.$cancelAutoSave;
export const $cleanupTicketNotesForm = atoms.$cleanupForm;
